"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_common_2 = require("@acko-tech/building-blocks.ui.common");
const img_1 = __importDefault(require("./img"));
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #ffffffab;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  opacity: 0.85;
`;
const Image = `
  width: 100px;
  height: 100px;
`;
function BasicLoader() {
    return (React.createElement(Container, null,
        React.createElement(img_1.default, { styles: Image })));
}
exports.default = BasicLoader;
//# sourceMappingURL=BasicLoader.js.map